<template>
  <!-- <div class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100" id="sidenav-collapse-main"> -->
  <div class="w-auto h-auto collapse navbar-collapse h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="dashboard"
          navText="Dashboard">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">dashboard</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="contacts" navText="Contacts">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">contacts</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="purchases"
          navText="Purchases">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">purchases</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="consultations"
          navText="Consultations">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">consultations</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="paidConsultations"
          navText="Consultation Price">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">consultation-price</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="levels"
          navText="Levels/Courses">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">levels</i>
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="promoCodes"
          navText="Promo Codes">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">promoCodes</i>
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="lessons" navText="Lessons">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">lessons</i>
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="questions" navText="Questions">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">questions</i>
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="userTests" navText="Quiz Results">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">quiz results</i>
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="availabilities"
          navText="Availability">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">availabilities</i>
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item">
        <sidenav-collapse url="#" :aria-controls="''" v-bind:collapse="false" collapseRef="sendEmail"
          navText="Send Email">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">send-email</i>
          </template>
        </sidenav-collapse>
      </li>



    </ul>

  </div>
</template>
<script>
import SidenavCollapse from "./SidenavCollapse.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      title: "Soft UI Dashboard PRO",
      controls: "dashboardsExamples",
      isActive: "active"
    };
  },
  components: {
    SidenavCollapse
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    logout() {
      this.$store.dispatch("auth/logout");
    }
  }
};
</script>
